import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/TimeTable.css';

const fallback = [
  { class: 'Class I – V', stream: 'Primary', file: null, session: '2025-26' },
  { class: 'Class VI – VIII', stream: 'Middle School', file: null, session: '2025-26' },
  { class: 'Class IX – X', stream: 'Secondary', file: null, session: '2025-26' },
  { class: 'Class XI – XII (Science)', stream: 'Senior Secondary', file: null, session: '2025-26' },
  { class: 'Class XI – XII (Commerce)', stream: 'Senior Secondary', file: null, session: '2025-26' },
];

export default function TimeTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(process.env.REACT_APP_TIMETABLE_API)
      .then((res) => setData(res.data?.length ? res.data : fallback))
      .catch(() => setData(fallback))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout bannerTitle="Time Table">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="School Time Table 2025-26" />
          <div className="timetable-info-box mt-4">
            <i className="fas fa-clock me-2"></i>
            <strong>School Timings:</strong> Morning Shift: 8:00 AM – 2:00 PM | Afternoon: 12:00 PM – 5:30 PM
          </div>
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
          ) : (
            <div className="table-responsive mt-4">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Class</th>
                    <th>Stream/Level</th>
                    <th>Session</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td><strong>{row.class}</strong></td>
                      <td>{row.stream}</td>
                      <td><span className="session-badge">{row.session}</span></td>
                      <td>
                        {row.file
                          ? <a href={row.file} target="_blank" rel="noreferrer" className="download-btn"><i className="fas fa-download me-1"></i>PDF</a>
                          : <span className="coming-soon-badge">Coming Soon</span>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
